export const MobileNavMenuActionType = {
    TOGGLE_NAV_MENU: "TOGGLE_NAV_MENU",
    HIT_MENU: "HIT_NAV_MENU",
};

interface IToggleMobileNavMenu {
    type: typeof MobileNavMenuActionType.TOGGLE_NAV_MENU,
}
interface IToggleMobileNavMenu {
    type: typeof MobileNavMenuActionType.HIT_MENU,
}

export type IMobileNavMenuActions = IToggleMobileNavMenu

export class MobileNavMenuActions {
    public static toggleNavMenu(): MobileNavMenuActions {
        return {
            type: MobileNavMenuActionType.TOGGLE_NAV_MENU,
        }
    }
    public static hitNavMenu(): MobileNavMenuActions {
        return {
            type: MobileNavMenuActionType.HIT_MENU,
        }
    }
}

